import { Component, OnInit, EventEmitter } from '@angular/core';
import { HttpService, MessageService, TableColumns, TableConfiguration, params, LocalStorageService, MenuBreadCrumb, enumRules, enumActions } from 'brainloper-ui';
import { MatDialog } from '@angular/material/dialog';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { ActivatedRoute } from '@angular/router';
import { ModalTypesComponent } from '../../../shared/modals-types/modal-types.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ItemsService } from 'app/services/items.service';
import { Area } from 'app/models2/administration/area';
import { JobTitle } from 'app/models2/administration/job-title';
import { Item } from 'app/models2/inventory/item';
import { EquipmentType } from 'app/models2/maintenance/equipment-type';
import { FrequentActivity } from 'app/models2/maintenance/frequent-activity';
import { UpdateData } from 'app/models2/commos/update-data';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { BaseResponse } from 'app/models2/commos/base-response';
@Component({
  selector: 'app-administration-data',
  templateUrl: './administration-data.component.html',
  styleUrls: ['./administration-data.component.scss']
})
export class AdministrationDataComponent implements OnInit {

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Datos Administración",
      current: true
    }]

  public urlGetDatosTipoEquipo: string = `${EndpointDictionary.EquipmentType.EQUIPMENT_TYPE_TABLE}`
  private urlPostTipoEquipo: string = `${EndpointDictionary.EquipmentType.CRUD_EQUIPMENT_TYPE_DATA}`
  public urlGetDatosActividadesFrecuentes: string = `${EndpointDictionary.ActivityeFrec.ACTIVITY_FREC_TABLE}`
  private urlPostActividadesFrecuentes: string = `${EndpointDictionary.ActivityeFrec.CRUD_ACTIVITY_FREC_DATA}`
  public urlGetDatosAreas: string = `${EndpointDictionary.Area.AREA_TABLE}`
  private urlCrudArea: string = `${EndpointDictionary.Area.CRUD_AREA_DATA}`
  public urlGetDatosJobTitle: string = `${EndpointDictionary.Position.POSITION_TABLE}`
  private urlCrudJobTitle: string = `${EndpointDictionary.Position.CRUD_POSITION_DATA}`
  public urlGetDataItem: string = `${EndpointDictionary.Item.ITEM_TABLE}`
  private urlCrudItem: string = `${EndpointDictionary.Item.CRUD_ITEM_DATA}`

  public inventoryModule: boolean = this.storage.get<boolean>('inventory_module')

  public rol: string = this.storage.get<string>('rol')

  //tabla Areas
  public reloadAreasTable = new EventEmitter<any>()
  public configurationAreas: TableConfiguration = {
    edit: true,
    add: true,
    primaryKey: 'id',
    addPer: true
  }
  public columnsAreas: TableColumns<Area>[] = [
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center'
      },
      required: true
    },
    {
      ID: 'responsible',
      label: 'Responsable',
      type: 'combo',
      style: {
        textAlign: 'center'
      },
      required: true,
      paramsCombo: {
        selectionField: 'userId',
        visibleField: 'name',
        url: `${EndpointDictionary.User.USER_COMBO}`,
      }
    },
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center'
      }
    },
    {
      ID: 'description',
      label: 'Descripcion',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      }
    },
  ]

  public isChecked: boolean = true
  public labelToggle: string = "Items activos"
  //tabla Item
  public paramsItem: params[] = [
    {
      id: 'active',
      value: 1
    }]

  public paramsItem2: params[] = [
    {
      id: 'active',
      value: 0
    }]

  public reloadItemTable = new EventEmitter<any>()
  public reloadItemInactiveTable = new EventEmitter<any>()
  public configurationItem: TableConfiguration = {
    edit: true,
    add: true,
    selectable: true,
    primaryKey: 'id',
    active: true
  }
  public configurationItemInactive: TableConfiguration = {
    selectable: true,
    primaryKey: 'id',
    active: true
  }
  public columnsItem: TableColumns<Item>[] = [
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
      required: true

    },
    {
      ID: 'itemName',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center',
      },
      required: true
    },
    {
      ID: 'costItem',
      label: 'Costo Unidad',
      type: 'number',
      style: {
        textAlign: 'center',
      },
      required: true
    },
    {
      ID: 'unitMeasurement',
      label: 'Medida',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ]

  //Tabla Cargos
  public columnsJobTitle: TableColumns<JobTitle>[] = [
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        width: '100%',
        textAlign: 'center'
      },
      required: true
    },

  ]
  public reloadJobTitleTable = new EventEmitter<any>()

  public configurationJobTitle: TableConfiguration = {
    add: true,
    edit: true,
    delete: false,
    selectable: false,
    primaryKey: 'id'
  }

  //Tabla Tipo Equipos
  public columnsEquipmentType: TableColumns<EquipmentType>[] = [
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        width: '100%',
        textAlign: 'center'
      },
      required: true
    }

  ]
  //public dataEquipmentType: Array<EquipmentType> = []
  reloadEquipmentTypeTable = new EventEmitter<any>()

  public configurationEquipmentType: TableConfiguration = {
    add: true,
    edit: true,
    delete: false,
    selectable:false,
    primaryKey: 'id'
  }

  //Actividades Frecuentes
  public columnsFrequentActivities: TableColumns<FrequentActivity>[] = [
    {
      ID: 'description',
      label: 'Descripcion',
      type: 'text',
      style: {
        width: '50%',
        textAlign: 'center'
      },
      required: true
    },
    {
      ID: 'cost',
      label: 'Costo',
      type: 'number',
      style: {
        width: '50%',
        textAlign: 'center'
      }
    }

  ]
  //public dataActividadesFrecuentes: Array<FrequentActivity> = []
  reloadFrequentActivitiesTable = new EventEmitter<any>()

  public configurationFrequentActivities: TableConfiguration = {
    add: true,
    edit: true,
    delete: true,
    selectable: true,
    primaryKey: 'id'
  }

  public expandedAdminData: IExpandedAdminData = {
    jobTitle: false,
    areas: false,
    itemInventory: false,
    equipmentTipe: false,
    frequentActivities: false
  }

  constructor(
    private http: HttpService,
    public dialog: MatDialog,
    private message: MessageService,
    private deleteItem: DeleteGenericService,
    private storage: LocalStorageService,
    private activeRoute: ActivatedRoute,
    private itemService: ItemsService
  ) {
  }

  ngOnInit(): void {
    let expandedParams
    this.activeRoute.queryParamMap
      .subscribe(async (params) => {
        expandedParams = { ...params };
        if (expandedParams.params.expanded && this.expandedAdminData[expandedParams.params.expanded] == false) {
          this.expandedAdminData[expandedParams.params.expanded] = true
        }
      })
  }


  //CRUD CARGOS

  async addJobTitle($event: JobTitle) {
    let form: JobTitle = {
      name: $event.name
    }

    await this.handlerData(this.urlCrudJobTitle, form, "post")
    this.reloadJobTitleTable.emit()

  }

  async editJobTitle($event: UpdateData<JobTitle>) {
    let form: JobTitle = {
      id: $event.old.id,
      name: $event.new.name
    }
    await this.handlerData(this.urlCrudJobTitle, form, "put")
    this.reloadJobTitleTable.emit()
  }

  async deleteJobTitle($event: JobTitle[]) {
    let res = await this.deleteItem.deleteD($event, this.urlCrudJobTitle, "id", "Cargo", "Cargos")
    this.reloadJobTitleTable.emit()
  }

  //CRUD TIPO EQUIPO

  async addEquipmentType($event: EquipmentType) {
    let form: EquipmentType = {
      name: $event.name
    }
    await this.handlerData(this.urlPostTipoEquipo, form, "post")
    this.reloadEquipmentTypeTable.emit()
  }

  async editEquipmentType($event: UpdateData<EquipmentType>) {
    let form: EquipmentType = {
      id: $event.old.id,
      name: $event.new.name,
    }

    await this.handlerData(this.urlPostTipoEquipo, form, "put")
    this.reloadEquipmentTypeTable.emit()
  }

  async deleteEquipmentType($event: EquipmentType[]) {
    let res = await this.deleteItem.deleteD($event, this.urlPostTipoEquipo, "id")
    this.reloadEquipmentTypeTable.emit()
  }

  //CRUD TIPO actvidades frecuentes

  async addFrequentActivities($event: FrequentActivity) {
    let form: FrequentActivity = {
      description: $event.description,
      cost: $event.cost
    }
    await this.handlerData(this.urlPostActividadesFrecuentes, form, "post")
    this.reloadFrequentActivitiesTable.emit()
  }

  async editFrequentActivities($event: UpdateData<FrequentActivity>) {
    let form: FrequentActivity = {
      id: $event.old.id,
      description: $event.new.description,
      cost: $event.new.cost
    }
    await this.handlerData(this.urlPostActividadesFrecuentes, form, "put")
    this.reloadFrequentActivitiesTable.emit()
  }

  async deleteFrequentActivities($event: FrequentActivity[]) {
    let res = await this.deleteItem.deleteD($event, this.urlPostActividadesFrecuentes, "id")
    this.reloadFrequentActivitiesTable.emit()
  }

  //CRUD Areas

  async addAreas($event: Area) {
    let size: number = screen.width > 500 ? 60 : 50;
    const dialogRef = this.dialog.open(ModalTypesComponent, {
      width: `${size}vh`,
      data: { name: "area" },
    }).afterClosed().subscribe(() => {
      this.reloadAreasTable.emit()
    });
  }

  async editAreas($event: UpdateData<Area>) {

    let form: Area = {
      id: $event.old.id,
      name: $event.new.name,
      description: $event.new.description,
      responsible: $event.new.responsible,
      code: $event.new.code

    }
    await this.handlerData(this.urlCrudArea, form, "put")
    this.reloadAreasTable.emit()
  }

  async deleteAreas($event: Area[]) {

    let res = await this.deleteItem.deleteD($event, this.urlCrudArea, "id", "Area", "Areas")
    this.reloadAreasTable.emit()
  }

  //CRUD ITEM

  async addItem($event: Item) {
    await this.handlerData(this.urlCrudItem, $event, "post")
    this.reloadItemTable.emit()
  }

  async editItem($event: UpdateData<Item>) {
    let form: Item = {
      id: $event.old.id,
      code: $event.new.code,
      itemName: $event.new.itemName,
      costItem: $event.new.costItem,
      unitMeasurement: $event.new.unitMeasurement,
      description: $event.new.description,
    }

    await this.handlerData(this.urlCrudItem, form, "put")
    this.isChecked ? this.reloadItemTable.emit() : this.reloadItemInactiveTable.emit()
  }

  async inactivateOrActiveItems($event: Item[], active: boolean) {
    await this.itemService.inactivateOrActiveItem($event, active)
    if (active) {
      this.reloadItemInactiveTable.emit()
    } else {
      this.reloadItemTable.emit()
    }
  }

  async handlerData(url: string, body, action: string) {
    let res: BaseResponse<GenericResponse>
    if (action == "post") {
      this.message.openLoading('Cargando', 'Creando dato')
    } else if (action == "put") {
      this.message.openLoading('Cargando', 'Actualizando dato')
    }

    try {
      if (action == "post") {
        res = await this.http.postDataPromise(url, body)
      } else if (action == "put") {
        res = await this.http.putDataPromise(url, body)
      }

      if (res['code'] === 0) {
        this.message.SuccessToast(res['message'])
        this.message.closeLoading()
      } else {
        this.message.closeLoading()
        this.message.Error('Error!', `Código: ${res['code']} - Mensaje : ${res['message']}`)
      }
    } catch (error) {
      this.message.Error('Error!', error.message)
      this.message.closeLoading()
    }
  }

  changeToggle($event: MatSlideToggleChange) {
    if ($event.checked) {
      this.labelToggle = "Items Activos"
    } else {
      this.labelToggle = "Items Inactivos"
    }
  }
}

interface IExpandedAdminData {
  areas: boolean;
  itemInventory: boolean;
  equipmentTipe: boolean;
  frequentActivities: boolean;
  jobTitle: boolean;
}



